<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoiceConfirm.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('invoiceConfirm.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-flex ts-justify-between">
            <div>
              <div>
                <input
                  v-model.trim="invoice_number"
                  type="text"
                  placeholder="Input invoice #"
                  class="ts-outline-none ts-border ts-border-l ts-py-2 ts-px-3 ts-rounded-tl-md ts-rounded-bl-md"
                />
                <button
                  class="ts-border-t ts-border-b ts-border-r ts-py-2 ts-px-3 ts-rounded-tr-md ts-rounded-br-md ts-text-blue-700 ts-font-extrabold ts-outline-none"
                  @click.prevent="onBarcodeScanned(invoice_number)"
                >
                  {{ $t('search') }}
                </button>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-8">
              <table class="ts-w-full">
                <thead>
                  <tr>
                    <th
                      class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-2"
                    >
                      <ts-checkbox
                        :checkedValue="isAllCheck"
                        @change="allCheckChange"
                        >All</ts-checkbox
                      >
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      Barcode
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      Product Name
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      Uom
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-24"
                    >
                      Order Qty
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-32"
                    >
                      Received Qty
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="ts-border-b ts-border-gray-300"
                    v-for="(p, index) in model.product_list"
                    :key="index"
                  >
                    <td class=" ts-py-2 ts-px-3">
                      <div class="checkbox checkbox-css">
                        <input
                          type="checkbox"
                          v-model="p.is_check"
                          :id="index"
                        />
                        <label :for="index"></label>
                      </div>
                    </td>
                    <td>
                      <ts-search-select
                        v-model="p.barcode"
                        :options="
                          products.map(el => ({
                            value: el.barcode,
                            text: el.barcode
                          }))
                        "
                        :filterFunction="filterProductFunction"
                        @change="barcodeChange(p)"
                      ></ts-search-select>
                    </td>
                    <td>
                      <ts-search-select
                        v-model="p.product_id"
                        :options="
                          products.map(el => ({
                            value: el.product_id,
                            text: el.product_name_en
                          }))
                        "
                        :filterFunction="filterProductFunction"
                        @change="productChange(p)"
                      ></ts-search-select>
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.product_id')"
                      >
                        {{ errors.first('details.' + index + '.product_id') }}
                      </div>
                    </td>
                    <td class=" ts-py-1 ts-px-3">{{ p.uom_name_en }}</td>
                    <td class=" ts-py-1 ts-px-3">
                      {{ p.original_qty }}
                    </td>
                    <td class=" ts-py-1 ts-px-3">
                      <input
                        type="number"
                        min="0"
                        v-model.number="p.deliver_qty"
                        class="ts-border ts-px-3 ts-py-1 ts-rounded-md ts-outline-none ts-w-16"
                        @change="e => qtyInputValidate(e, p.original_qty, p)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <textarea
                v-model="model.confirm_comment"
                placeholder="Comments..."
                class="form-control ts-mt-3"
                rows="3"
              ></textarea>
              <div class="ts-flex ts-space-x-3">
                <ts-button
                  @click="$router.push('/invoice-confirm')"
                  class="ts-mt-3"
                  >{{ $t('cancel') }}
                </ts-button>
                <ts-button color="primary" @click="onStore" class="ts-mt-3"
                  >{{ $t('confirm') }}
                </ts-button>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="ts-flex ts-space-x-5 ts-border ts-border-blue-300 ts-rounded-md ts-p-4"
              >
                <div class="ts-w-56 ts-h-48 ts-rounded-sm ts-overflow-hidden">
                  <img
                    :src="student.photo ? student.photo : default_imag"
                    alt=""
                    @error="setAltImg"
                    class="ts-object-fill"
                  />
                </div>
                <div class="ts-w-full ts-space-y-3">
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.studentName') }} : </strong>
                    <p>{{ student.full_name_en }}</p>
                  </div>
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.cardNumber') }} : </strong>
                    <p>{{ student.card_number }}</p>
                  </div>
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.sex') }} : </strong>
                    <p>{{ student.gender }}</p>
                  </div>
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.grade') }} : </strong>
                    <p>{{ invoices.grade_name_foreign }}</p>
                  </div>
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.className') }} : </strong>
                    <p>{{ invoices.class_name }}</p>
                  </div>
                  <div
                    class="ts-flex ts-justify-between ts-border-b ts-border-gray-300"
                  >
                    <strong>{{ $t('invoiceConfirm.studyTime') }} : </strong>
                    <p>{{ invoices.study_time }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import Vue from 'vue'
import VueBarcodeScanner from 'vue-barcode-scanner'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { cloneDeep, isEmpty } from 'lodash'

let options = {
  // sound: true, // default is false
  // soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300 // default is 100
  // requiredAttr: true, // default is false
  // controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  // callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options)

export default {
  name: 'invoiceScan',
  data () {
    return {
      loading: false,
      invoice_number: null,
      default_imag: require('@/assets/student_default.png'),
      student: {
        photo: undefined,
        full_name_en: undefined,
        card_number: undefined,
        gender: undefined
      },
      invoices: {
        grade_name_foreign: undefined,
        class_name: undefined,
        study_time: undefined
      },
      model: {
        inv_id: null,
        confirm_comment: null,
        product_list: []
      },
      errors: new Errors(),
      products: []
    }
  },
  created () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
    this.products = []
    this.loading = true
    this.getProduct()
      .then(response => {
        this.products = response.data
        var invoiceNumber = this.$route.query.invoice_number
        if (invoiceNumber) {
          this.$nextTick(() => {
            this.onBarcodeScanned(invoiceNumber)
          })
        }
      })
      .catch(error => {
        this.$toasted.error(error.message)
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    isAllCheck () {
      if (this.model.product_list.length > 0) {
        return (
          this.model.product_list.length ==
          this.model.product_list.filter(e => e.is_check == true).length
        )
      }

      return false
    }
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  methods: {
    ...mapActions('invoiceConfirm', ['scanInvoice', 'store', 'getProduct']),
    filterProductFunction (search, options) {
      return options.filter(option => {
        option = typeof option === 'object' ? option.text : option

        return option.toLowerCase().includes(search.toLowerCase())
      })
    },
    barcodeChange (item) {
      if (!item.barcode) {
        item.product_id = ''
        return
      }
      let result = this.products.find(p => p.barcode == item.barcode)
      item.product_id = result.product_id
    },
    productChange (item) {
      if (!item.product_id) {
        item.barcode = ''
        return
      } else {
        let result = this.products.find(p => p.product_id == item.product_id)
        item.barcode = result.barcode
      }
    },
    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScanned (barcode) {
      this.invoice_number = barcode
      this.$nextTick(() => {
        this.loading = true
      })
      this.scanInvoice({
        invoice_number: this.invoice_number
      })
        .then(response => {
          if (!isEmpty(response.data)) {
            let { student, ...invoice } = response.data
            this.student = student
            this.invoices = invoice
            this.model.inv_id = invoice.inv_id
            this.model.product_list = []
            invoice.stock_out_from_invoice.forEach(element => {
              this.model.product_list.push(
                Object.assign({}, element, {
                  is_check: true,
                  original_qty: element.quantity,
                  deliver_qty: element.quantity
                })
              )
            })
          }
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.invoice_number = null
          this.loading = false
        })
    },
    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode () {
      let barcode = this.$barcodeScanner.getPreviousCode()
      // do something...
    },
    setAltImg (event) {
      event.target.src = this.default_imag
    },
    allCheckChange (e) {
      if (e) {
        this.model.product_list.forEach(el => (el.is_check = true))
      } else {
        this.model.product_list.forEach(el => (el.is_check = false))
      }
    },
    qtyInputValidate (e, originQty, row) {
      var value = e.target.value
      if (!value || value > originQty || value < 0) {
        row.quantity = originQty
      }
    },
    onStore () {
      this.loading = true
      this.errors = new Errors()
      var newModel = cloneDeep(this.model)
      newModel.product_list = this.model.product_list.filter(el => el.is_check)
      this.store(newModel)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.replace({ path: '/invoice-confirm/scanners' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.student.photo = undefined
      this.student.full_name_en = undefined
      this.student.card_number = undefined
      this.student.gender = undefined

      this.invoices.grade_name_foreign = undefined
      ;(this.invoices.class_name = undefined),
        (this.invoices.study_time = undefined)

      this.model.inv_id = null
      this.model.confirm_comment = null
      this.model.product_list = []
    }
  }
}
</script>
